import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot} from '@angular/router';
import {UsuarioServices} from './usuario.services';
import {Observable} from 'rxjs';

@Injectable()
export class CoreSecurityServices implements CanActivate{
  constructor(private us:UsuarioServices){}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    let isLogin = this.us.isLogin();

    if(isLogin){
      return true;
    }
    else{
      this.us.irALogin();
      return false;
    }
  }
}
